// extracted by mini-css-extract-plugin
export var growableInput = "_5m-0";
export var tagContainer = "_5m-2";
export var textInput = "_5m-1";